import * as React from "react";

import type { Side, GameState, MoveSequence } from "../../core/types";
import type { PlayAction, ResetGameAction } from "../../reducer";

type MoveHistoryItem = {
  action: PlayAction | ResetGameAction;
  sequence: Array<MoveSequence>;
};

type StateProperties = {
  nextPlayer: Side;
  gameState: GameState;
  moveHistory?: Array<MoveHistoryItem>;
};
export type ContextType = {
  properties: StateProperties;
  setStateProperties?: (stateProperties: StateProperties) => void;
};
const GameStatePropertiesContext: React.Context<ContextType | undefined> = React.createContext<ContextType | undefined>(
  undefined
);
export default GameStatePropertiesContext;
export type { MoveHistoryItem };
